import { Injectable, NgZone } from '@angular/core';
import { fromEvent, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
@Injectable({
  providedIn: 'root'
})
export class ViewPortService {

  constructor(private ngZone: NgZone) { }

  getViewportResizeEvent(): Observable<VisualViewport> {
    return new Observable<VisualViewport>(observer => {
      if ('visualViewport' in window) {
        const visualViewport = window.visualViewport;

        const resizeListener = () => {
          // this.ngZone.run(() => {
            console.log('Viewport resized:', visualViewport.width, visualViewport.height,visualViewport,18);
            observer.next(visualViewport);
          // });
        };

        visualViewport.addEventListener('resize', resizeListener);
        console.log('VisualViewport resize listener added.',visualViewport, visualViewport,24);

        // Clean up the event listener when the observable is unsubscribed
        return () => {
          visualViewport.removeEventListener('resize', resizeListener);
          console.log('VisualViewport resize listener removed.');
        };
      } else {
        observer.error('Visual Viewport API is not supported in this browser.');
      }
    });
  }

}
